// @flow
import { trackLinkWithData, trackImpression } from 'lib/analytics/fpti'

export const SEND_PAGE_GROUP = 'main:p2p:tab-send::start'
export const SEND_PAGE_NAME = 'main:p2p:tab-send::start:node::'
export const REQUEST_PAGE_GROUP = 'main:p2p:tab-request::start'
export const REQUEST_PAGE_NAME = 'main:p2p:tab-request::start:node::'
export const SEARCH_CONSENT_PAGE_GROUP = 'main:p2p:consentdirsearch::'
export const SEARCH_CONSENT_PAGE_NAME =
  'main:p2p:consentdirsearch:useragreement::'

const PAGE_VARIANT_MAP = {
  SIGNUP_FOR_NETWORK_ID: 'E',
  UPGRADE_NETWORK_ID: 'A',
  PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT: 'F',
}

/**
 * Track directory search impression via FPTI analytics
 * @param {Object} data - data to track with the impression
 */
export function trackSearchResultImpression(
  isRequestFlow: boolean,
  device_contacts_count: number,
  paypal_contacts_count: number
) {
  const pageGroup = isRequestFlow ? REQUEST_PAGE_GROUP : SEND_PAGE_GROUP
  const pageName = isRequestFlow ? REQUEST_PAGE_NAME : SEND_PAGE_NAME
  let data = { device_contacts_count, paypal_contacts_count }
  if (device_contacts_count === 0 && paypal_contacts_count === 0) {
    data = { ...data, int_err_code: '500', int_err_code_desc: 'tbd' }
  }
  trackImpression(pageGroup, pageName, data)
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} isRequestFlow - is in request flow
 * * @param {Object} linkName - the link name
 */
export function trackDirectorySearchClick(
  isRequestFlow: boolean,
  linkName: Object
) {
  const pageGroup = isRequestFlow ? REQUEST_PAGE_GROUP : SEND_PAGE_GROUP
  const pageName = isRequestFlow ? REQUEST_PAGE_NAME : SEND_PAGE_NAME
  trackLinkWithData(linkName, pageGroup, pageName, 'link')
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} isRequestFlow - is in request flow
 * * @param {Object} linkName - the link name
 */
export function trackContactClick(isRequestFlow: boolean, contact: Object) {
  const pageGroup = isRequestFlow ? REQUEST_PAGE_GROUP : SEND_PAGE_GROUP
  const pageName = isRequestFlow ? REQUEST_PAGE_NAME : SEND_PAGE_NAME
  const data = {
    recipient_ppme_member_y_n: Boolean(contact.hasNetworkId).toString(),
    account_type: contact.isUnilateral ? 'GUEST' : 'MEMBER',
  }
  trackLinkWithData('CONTACT_ID', pageGroup, pageName, data, 'link')
}

/**
 * Track directory search impression via FPTI analytics
 * @param {Object} data - data to track with the impression
 */
export function trackConsentImpression(actionType: string, isPreFlow: boolean) {
  const variant = PAGE_VARIANT_MAP.hasOwnProperty(actionType)
    ? PAGE_VARIANT_MAP[actionType]
    : ''
  if (variant) {
    trackImpression(SEARCH_CONSENT_PAGE_GROUP, SEARCH_CONSENT_PAGE_NAME, {
      page_variant: `Version_${variant}`,
      fltp: isPreFlow ? 'PRE' : 'IN',
    })
  }
}

/**
 * Track consent page click via FPTI analytics
 * @param {Object} actionType - data to track with the impression
 * * @param {Object} linkName - data to track with the impression
 */
export function trackConsentClick(actionType: string, linkName: string) {
  const variant = PAGE_VARIANT_MAP.hasOwnProperty(actionType)
    ? PAGE_VARIANT_MAP[actionType]
    : ''
  if (variant) {
    trackLinkWithData(
      linkName,
      SEARCH_CONSENT_PAGE_GROUP,
      SEARCH_CONSENT_PAGE_NAME,
      { page_variant: `Version_${variant}` },
      'link'
    )
  }
}
